import { render } from "./SetWinnersDialog.vue?vue&type=template&id=218f3010&scoped=true"
import script from "./SetWinnersDialog.vue?vue&type=script&lang=js"
export * from "./SetWinnersDialog.vue?vue&type=script&lang=js"

import "./SetWinnersDialog.vue?vue&type=style&index=0&id=218f3010&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-218f3010"]])

export default __exports__